import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { FileUpload } from '@app/entity';
import { head } from '@app/shared/utils';
import 'rxjs/add/operator/finally';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit, OnDestroy {
  // file-only props
  @Input() accepts: string[] = [];
  @Input() maxSize: number = 100 * 1024 * 1024;
  @Input() currentFileUpload: FileUpload = null;
  @Input() hasError: boolean;
  @Output() onFileUploaded = new EventEmitter<FileUpload>();

  progress = 0;
  isLoading = false;
  isDragging = false;
  error = null;

  private uploadSubscription: Subscription;

  constructor(private http: HttpClient) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.uploadSubscription) this.uploadSubscription.unsubscribe();
  }

  onDragOver(event: DragEvent) {
    this.stop(event);
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    this.stop(event);
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    this.stop(event);
    this.isDragging = false;
    this.onFileSelected(event, event.dataTransfer.files);
  }

  stop(event: Event) {
    event.stopPropagation();
    event.preventDefault();
  }

  onFileSelected(event: Event, files: FileList) {
    this.error = null;
    this.uploadFile(files);
  }

  private uploadFile(files: FileList) {
    if (files.length === 0) return;
    this.error = null;
    const current: File = files.item(0);

    if (!this.validateExtension(current)) return;
    if (!this.validateSize(current)) return;

    this.isLoading = true;

    if (this.uploadSubscription) this.uploadSubscription.unsubscribe();

    const data = new FormData();
    data.append('file', current);
    this.uploadSubscription = this.http.post<FileUpload>('/file_upload/', data, {
      reportProgress: true,
      observe: 'events',
    })
      .finally(() => this.isLoading = false)
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = 100 * event.loaded / event.total;
        } else if (event.type === HttpEventType.Response) {
          this.onFileUploaded.next(event.body);
          this.currentFileUpload = event.body;
        }
      }, error => {
        const message = 'Не удалось загрузить файл';
        this.error = head(error.error['non_field_errors']) || head(error.error['file']) || message;
        this.currentFileUpload = null;
      });
  }

  private validateSize(file: Blob): boolean {
    if (file.size < this.maxSize) return true;
    this.error = `Слишком большой файл. Размер файла не должен превышать ${Math.floor(this.maxSize / (1024 * 1024))} Мб`;
    return false;
  }

  private validateExtension(file: File): boolean {
    if (!this.accepts || this.accepts.length === 0) return true;
    if (this.accepts.find(ext => file.name.endsWith(ext))) return true;
    this.error = `Недопустимый тип файла. Разрешенные форматы: ${this.accepts.join(', ')}`;
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/file-upload/file-upload.component.ts